import { useContext } from 'react';
import { SaveBarContext } from '../context/SaveBarProvider';

export const useSaveBar = () => {
    const context = useContext(SaveBarContext);
    if (!context) {
        throw new Error('useSaveBar must be used within a SaveBarProvider');
    }
    return context;
};
